import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { StorefrontIcon } from '@yonderland/andes-icons';
import { Box, Divider, Icon, LinkButton, Switch, TextAlpha } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import StoreAPI from '../../../../api/store/StoreAPI';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { SELECTED_STORE_STORAGE_KEY } from '../../../../constants/StorageKeysConstants';
import LocalStorageUtil from '../../../../util/LocalStorageUtil';
const InStoreFilterMobile = ({ inStoreFilter, activeStoreId, handleOpenPopup, updateInStoreFilter, updateStoreId, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const handleFilterChange = () => updateStoreId(inStoreFilter === null || inStoreFilter === void 0 ? void 0 : inStoreFilter.storeId);
    const getStoreInfo = (storeId, servicesApi, requestParams) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const store = yield StoreAPI.getStoreInfoByStoreId(servicesApi, requestParams, storeId);
            updateInStoreFilter === null || updateInStoreFilter === void 0 ? void 0 : updateInStoreFilter(store);
            LocalStorageUtil.setItem(SELECTED_STORE_STORAGE_KEY, store);
        }
        catch (_a) { }
    });
    useEffect(() => {
        if (!activeStoreId || (activeStoreId && activeStoreId === (inStoreFilter === null || inStoreFilter === void 0 ? void 0 : inStoreFilter.storeId))) {
            return;
        }
        getStoreInfo(activeStoreId, servicesEndpoint, defaultRequestParams);
    }, [activeStoreId, servicesEndpoint, defaultRequestParams, inStoreFilter]);
    return (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Box, { padding: "4", backgroundColor: "informative-bg", borderRadius: "lg", children: _jsxs(Grid, { templateColumns: "20px 1fr 32px", gap: "s", children: [_jsx(Icon, { source: StorefrontIcon, size: "md" }), _jsxs(Box, { children: [_jsx(TextAlpha, { strong: true, children: t('product.lister.inStore.mobile.from') }), inStoreFilter && (_jsxs(TextAlpha, { as: "span", color: "subtle", children: [inStoreFilter.storeName, ' '] })), _jsx(LinkButton, { onClick: handleOpenPopup, text: inStoreFilter
                                        ? `(${t('product.lister.inStore.mobile.change')})`
                                        : t('product.lister.inStore.mobile.chooseStore') })] }), _jsx(Switch, { checked: !!activeStoreId, id: "in_store_filter", onChange: handleFilterChange })] }) })] }));
};
export default InStoreFilterMobile;
